var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23166_68584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39177 7.63672L3.66177 7.49172C3.96677 7.45672 4.26677 7.56172 4.48177 7.77672L5.40177 8.69672C6.81677 7.97672 7.97677 6.82172 8.69677 5.40172L7.77177 4.47672C7.55677 4.26172 7.45177 3.96172 7.48677 3.65672L7.63177 2.39672C7.69177 1.89172 8.11677 1.51172 8.62677 1.51172H9.49177C10.0568 1.51172 10.5268 1.98172 10.4918 2.54672C10.2268 6.81672 6.81177 10.2267 2.54677 10.4917C1.98177 10.5267 1.51177 10.0567 1.51177 9.49172V8.62672C1.50677 8.12172 1.88677 7.69672 2.39177 7.63672Z",
    fill: "#51B15C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23166_68584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.672f2562496bbfcea64fab8752d7533c.svg";
export { ForwardRef as ReactComponent };